<template>
    <kiosk-layout>
        <div>
            <page-header class="mb-6 lg:mb-12">Cloning</page-header>
            <div class="grid grid-cols-12">
                <page-sidebar
                    :links="[
                        { href: `/kiosk/cloning/targets`, label: 'Cloning Targets' },
                        { href: `/kiosk/cloning/teams`, label: 'Clone Teams' },
                    ]"
                ></page-sidebar>

                <slot></slot>
            </div>
        </div>
    </kiosk-layout>
</template>

<script setup>
import KioskLayout from '~/components/kiosk/KioskLayout.vue';
import PageHeader from '~/components/general/PageHeader.vue';
import PageSidebar from '~/components/general/PageSidebar.vue';
</script>
